<wbo-edit-grid [data]="model.data[fieldName]" [editable]="true" [removable]="true" [entityPath]="fieldName" [title]="'wbo.report.inventory-selection.title'">
    <wbo-text-column field="name" [title]="'wbo.report.inventory-selection.column.name'"></wbo-text-column>
    <wbo-text-column field="inventorygroup" [title]="'wbo.report.inventory-selection.column.inventorygroup'"></wbo-text-column>
    <wbo-edit-grid-add-row [customAdd]="true">
        <wbo-edit-grid-add-row-quick-add (onSelect)="addFromInventory([$event])">
            <wbo-inventory-single-select-edit-control></wbo-inventory-single-select-edit-control>
        </wbo-edit-grid-add-row-quick-add>
        <wbo-edit-grid-add-row-actions>
            <wbo-edit-grid-add-row-search [searchComponent]="InventorySearchPageComponent" [searchParams]="{filterNonStockable : false}" (onSelect)="addFromInventory($event)"></wbo-edit-grid-add-row-search>
        </wbo-edit-grid-add-row-actions>
    </wbo-edit-grid-add-row>
</wbo-edit-grid>
